import { useTranslation } from "react-i18next";
import React, { useCallback } from "react";
import { IErrorFallbackProps } from "./interface";
import { Button, Result } from "src/assets/imports/antdComponents";

const ErrorFallback: React.FC<IErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
	const { t } = useTranslation();

	const redirectToHome = useCallback(() => {
		window.location.href = "/"; // This will navigate to the home page and reload the app
	}, []);

	const reload = useCallback(() => {
		window.location.reload(); // This will reload the current page
	}, []);

	return (
		<div role="alert" className="flex w-full h-full justify-center item-center">
			<Result
				status="500"
				title={t("We are sorry! Something went wrong while accessing this page")}
				subTitle={t("We request you to try after some time or contact support for help")}
				extra={
					<>
						<Button type="primary" className="mr-5" onClick={reload}>
							{t("Refresh")}
						</Button>
						<Button onClick={redirectToHome}>{t("Go to Home")}</Button>
					</>
				}
			/>
		</div>
	);
};

export default ErrorFallback;
